import { useSessionExpirationMonitor } from './useSessionExpirationMonitor';

/**
 * Component that monitors the session expiration and preemptively logs out the user
 * before the session expires to prevent 401 errors.
 *
 * This should be placed inside the Refine provider component.
 */
export const SessionExpirationMonitor = () => {
  useSessionExpirationMonitor();
  return null;
};
